import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromRadioChannels from './radio-channels.reducer';

export interface State {
  radioChannels: fromRadioChannels.RadioChannelsState;
}

export const reducers: ActionReducerMap<State> = {
  radioChannels: fromRadioChannels.radioChannelReducer,
};

export const selectRadioChannelsState = createFeatureSelector<fromRadioChannels.RadioChannelsState>(
  fromRadioChannels.inRoomRadioChannelsFeatureKey
);

export const selectRadioChannelsEntities = createSelector(
  selectRadioChannelsState,
  fromRadioChannels.selectRadioChannelEntities
);

export const getRadioChannel = (radioChannelId: string) =>
  createSelector(selectRadioChannelsEntities, (entities) => entities[radioChannelId]);
